/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserBank { 
    id?: string;
    user_id?: string;
    bank_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    name_on_card?: string;
    card_number?: string;
    bank_account?: string;
    branches?: string;
    is_active?: boolean;
    company?: string;
    company_id?: string;
}